import $ from 'jquery';
import ProductQuickshop from '../snippets/ProductQuickshop';

export default class ProductItem {
  constructor($el, postMessage) {
    this.$el = $el;
    this.postMessage = postMessage;

    if (this.$el.is('[data-use-quickshop]')) {
      const productQuickshopMarkup = $('[data-quickshop-markup]', this.$el).text();

      try {
        this.productQuickshop = new ProductQuickshop(
          this.$el,
          $(JSON.parse(productQuickshopMarkup)),
          this.postMessage
        );
      } catch(error) {
        console.warn(`Product item: invalid quickshop data found. ${error.message}`);
        return;
      }
    }

    this._objectFitPolyfill();
  }

  _isObjectFitAvailable() {
    return 'objectFit' in document.documentElement.style;
  }

  _objectFitPolyfill() {
    if (this._isObjectFitAvailable()) {
      return;
    }

    const $image = $('[data-product-item-image]', this.$el);
    const src = $('img', $image).attr('src');

    $image.addClass('product-item-image-no-objectfit');
    $image.css('background-image', `url("${ src }")`);
  }

  unload() {
    if (this.productQuickshop) {
      this.productQuickshop.unload();
    }
  }
}
